angular.module('ApptBookApp').directive('meevoNewExperienceBanner', [
    'appointmentBookNewExperienceBannerService',
    '$rootScope',
    '$timeout',
    '$translate',
    function (bannerService: any, $rootScope: angular.IRootScopeService, $timeout: angular.ITimeoutService, $translate: angular.translate.ITranslateService) {
        return {
            restrict: 'E',
            scope: {
                areaKey: '@?',
            },
            templateUrl: 'app/components/newExperienceBanner/newExperienceBanner.template.html',
            link: function (scope: any, element: JQuery) {
                const resolvedAreaKey = String(scope.areaKey || '').trim();
                scope.vm = {
                    area: $translate.instant(resolvedAreaKey),
                    shouldShow: function () {
                        return bannerService.shouldShow(resolvedAreaKey);
                    },
                    dismiss: function () {
                        bannerService.dismiss();
                    },
                    switchToNew: function () {
                        bannerService.switchToNew(resolvedAreaKey);
                    },
                };

                // #divApptBookHeader is position:fixed with a hardcoded top offset, so it
                // does not shift down for in-flow content above it. Publish the banner's
                // real rendered height as a CSS variable so the header (and its mobile
                // media-query override) can push themselves below the banner instead of
                // rendering on top of it.
                const root = document.documentElement;
                const hostEl = element[0] as HTMLElement;
                // Track the last published height so we only trigger a relayout when
                // the banner's footprint actually changes (rendered, dismissed, or
                // reflowed) — not on every measure tick.
                let lastHeight = -1;
                const publishHeight = (height: number) => {
                    if (height === lastHeight) {
                        return;
                    }
                    lastHeight = height;
                    root.style.setProperty('--new-experience-banner-height', height + 'px');
                    // The legacy grid positions itself from a JS-computed header offset
                    // (globals.headerOffset) that bakes in the banner height at build
                    // time and is otherwise never recomputed. Without this, dismissing
                    // the banner leaves the reserved space behind, and a late-rendered
                    // banner throws off empty-cell hit-testing. Tell the builder to
                    // recompute against the banner's current footprint.
                    $rootScope.$broadcast(Meevo.Components.Common.Messages.APPOINTMENT_BOOK_RELAYOUT);
                };
                // The banner itself is position:fixed, so it carries no flow height of
                // its own to observe — track whichever rendered inner element ng-if
                // currently has in the DOM, re-targeting the observer each time ng-if
                // swaps it in/out (hidden/dismissed collapses back to zero).
                let observedInner: HTMLElement | null = null;
                const resizeObserver = new ResizeObserver(() => {
                    publishHeight(observedInner ? observedInner.offsetHeight : 0);
                });
                const measure = () => {
                    const inner = hostEl.querySelector('.new-experience-banner') as HTMLElement | null;
                    if (inner !== observedInner) {
                        if (observedInner) {
                            resizeObserver.unobserve(observedInner);
                        }
                        observedInner = inner;
                        if (inner) {
                            resizeObserver.observe(inner);
                        }
                    }
                    publishHeight(inner ? inner.offsetHeight : 0);
                };

                // Re-measure whenever the banner's visibility flips (first render,
                // dismiss, or switch-to-new), after the digest has added/removed the
                // ng-if content. This is what keeps the grid's reserved header space and
                // empty-cell hit-testing in sync with whether the banner is showing, and
                // hands the new element off to the ResizeObserver above for ongoing
                // reflow safety (viewport width causing it to wrap, font load, etc).
                scope.$watch(
                    () => scope.vm.shouldShow(),
                    () => { $timeout(measure); }
                );

                scope.$on('$destroy', function () {
                    resizeObserver.disconnect();
                    publishHeight(0);
                });
            },
        };
    }
]);
